import faker from 'faker'
import moment from 'moment'
import hres6keLabels from 'assets/labels/hres6ke'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres6keLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        staappr: '',
        codempid: faker.random.number(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number().toString().substr(0, 1),
        dteot: moment().format('DD/MM/YYYY') + ' - ' + moment().format('DD/MM/YYYY'),
        timbstr: faker.date.past().toString().substr(16, 5),
        timdstr: faker.date.past().toString().substr(16, 5),
        timastr: faker.date.past().toString().substr(16, 5) + ' - ' + faker.date.past().toString().substr(16, 5),
        remark: faker.lorem.words(),
        desrem: faker.lorem.words(),
        status: faker.lorem.words(),
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remarkap: faker.lorem.words(),
        desc_codempap: faker.lorem.word()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codinput: faker.finance.mask(),
      desc_codinput: faker.name.findName(),
      codempid: faker.finance.mask(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      dtestrt: moment().format('DD/MM/YYYY'),
      dteend: moment().format('DD/MM/YYYY'),
      timbstr: faker.date.past().toString().substr(16, 5),
      timbend: faker.date.past().toString().substr(16, 5),
      timdstr: faker.date.past().toString().substr(16, 5),
      timdend: faker.date.past().toString().substr(16, 5),
      timastr: faker.date.past().toString().substr(16, 5),
      timaend: faker.date.past().toString().substr(16, 5),
      codrem: faker.finance.mask(),
      desc_codrem: faker.name.findName(),
      remark: faker.lorem.word()
    }
    let mockTab2 = {
      codempid: faker.finance.mask(),
      desc_codempid: faker.name.findName(),
      dteworkst: moment().format('DD/MM/YYYY'),
      dteend: moment().format('DD/MM/YYYY')
    }
    let mockTab2Rows = []
    const mockTab2Total = 5
    for (var i = 1; i <= mockTab2Total; i++) {
      mockTab2Rows.push({
        id: i,
        dtework: moment().format('DD/MM/YYYY'),
        typwork: faker.address.stateAbbr().toString().substr(1, 1),
        typot: faker.address.stateAbbr(),
        v_ot_time: faker.date.past().toString().substr(16, 5) + '-' + faker.date.past().toString().substr(16, 5)
      })
    }
    let mockTab3 = {
      codempid: faker.finance.mask(),
      desc_codempid: faker.name.findName()
    }
    let mockTab3Rows = []
    const mockTab3Total = 5
    for (var a = 1; a <= mockTab3Total; a++) {
      mockTab3Rows.push({
        id: a,
        dtework: moment().format('DD/MM/YYYY'),
        typwork: faker.address.stateAbbr().toString().substr(1, 1),
        codshift: faker.finance.mask(),
        timework: faker.date.past().toString().substr(16, 5) + ' - ' + faker.date.past().toString().substr(16, 5),
        timin: faker.date.past().toString().substr(16, 5),
        timout: faker.date.past().toString().substr(16, 5)
      })
    }

    return {
      tab1: mockTab1,
      tab2: {
        detail: mockTab2,
        table: {
          total: mockTab2Total,
          rows: mockTab2Rows
        }
      },
      tab3: {
        detail: mockTab3,
        table: {
          total: mockTab3Total,
          rows: mockTab3Rows
        }
      }
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6lu/mocker.js